import importReact from "../../utils/importReact";

export default function initIndustryInsights() {
  const entrypoint = document.getElementById("insights-container");
  if (entrypoint) {
    import(
      /* webpackChunkName: "industryInsights" */ "./IndustryInsights"
    ).then((e) => {
      const pageSize = parseInt(entrypoint.dataset.pagesize ?? "");
      const currentPageRef = parseInt(entrypoint.dataset.currentpage ?? "");
      importReact().then(([React, ReactDOM]) => {
        ReactDOM.render(
          React.createElement(e.default, { pageSize, currentPageRef }),
          entrypoint
        );
      });
    });
  }
}
